import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FlagRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { useSelector } from 'react-redux';
import useIpLocation from '@src/hooks/useLocation';
import { LANDING_PAGE_URL } from '@src/configs';
import { CATEGORY_TYPE, PLATFORM_TYPE } from '@src/constants/support';
import ErrorReport from '../Requests/ErrorReport';
import { StyledErrorReportButton } from './index.style';

const ErrorReportButton = ({ request = {} }) => {
  const { t } = useTranslation();
  const { ip } = useIpLocation();
  const { user } = useSelector((state) => state.auth);
  const { getFeatureValue } = useFeatureFlags();
  const useNewContactSupport = getFeatureValue(
    FEATURE_KEYS.NEW_CONTACT_SUPPORT,
    {
      ip,
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    },
  );
  const { id: requestId, voice } = request;
  const [openErrorReport, setOpenErrorReport] = useState(false);

  const handleOpenErrorReport = (e) => {
    e.stopPropagation();
    const ticketMetadata = {
      requestId,
      voiceCode: voice.code,
      userId: user.id,
    };
    const base64TicketMetadata = btoa(JSON.stringify(ticketMetadata));
    const encodedTicketMetadata = encodeURIComponent(base64TicketMetadata);

    if (useNewContactSupport) {
      window.open(
        `${LANDING_PAGE_URL}/support?metadata=${encodedTicketMetadata}&platform=${PLATFORM_TYPE.DESKTOP_WEB}&category=${CATEGORY_TYPE.TTS}`,
        '_blank',
      );
    } else {
      setOpenErrorReport(true);
    }
  };

  const handleCloseErrorReport = () => setOpenErrorReport(false);

  return (
    <StyledErrorReportButton>
      <Button
        className="error-report-button"
        variant="outlined"
        size="small"
        startIcon={<FlagRounded className="flag-icon" />}
        onClick={handleOpenErrorReport}
      >
        <span>{t('errorReport')}</span>
      </Button>

      <ErrorReport
        open={openErrorReport}
        request={request}
        onClose={handleCloseErrorReport}
      />
    </StyledErrorReportButton>
  );
};

export default ErrorReportButton;
